import { NAVIGATOR_GRID_GAP } from '../i18n/const';

// Mobile: At least 3 column per row. Page width changing based on device width
// Tablet/desktop: Page always around 150px width, changing based on device width to fit grid size
export default (function (page, gridWidth) {
  var _page$images, _page$images2;
  var thumbnailWidth = (page === null || page === void 0 || (_page$images = page.images) === null || _page$images === void 0 || (_page$images = _page$images.thumbnail) === null || _page$images === void 0 ? void 0 : _page$images.width) || 0;
  var thumbnailHeight = ((_page$images2 = page.images) === null || _page$images2 === void 0 || (_page$images2 = _page$images2.thumbnail) === null || _page$images2 === void 0 ? void 0 : _page$images2.height) || 0;
  var numOfPages = 0;
  if (thumbnailWidth && thumbnailHeight && gridWidth) {
    numOfPages = Math.max(Math.floor(gridWidth / 150), 3);
    // calculate total gap and borders size to get correct thumb width
    var spaceBetweenPages = (NAVIGATOR_GRID_GAP + 4) * numOfPages;
    var pageWidth = Math.floor((gridWidth - spaceBetweenPages) / numOfPages);
    thumbnailHeight *= pageWidth / thumbnailWidth;
    thumbnailWidth = pageWidth;
  }
  return {
    width: thumbnailWidth,
    height: Math.round(thumbnailHeight),
    gridColumns: numOfPages
  };
});